import styled from 'styled-components';

const InlineLink = styled.a`
  color: ${({ theme }) => theme.colors.robinsEggBlue};
  text-decoration: none;
`;

export default InlineLink;
